import React, { type FC, type ReactNode } from 'react';
import { Navigate } from 'react-router';

import { ISSUPPORTER } from '../constants/global';
import { pageurl } from '../constants/pageurl';

// Nested inside AdminRoute. Settings and its pages (agent profile, bank details, government ID) are
// not an Independent Supporter's; a typed URL lands them back on their home.
const NotSupporterRoute: FC<{ children: ReactNode }> = ({ children }) => {
	if (ISSUPPORTER()) {
		return (
			<Navigate
				to={pageurl.OVERVIEW}
				replace
			/>
		);
	}
	return <>{children}</>;
};

export default NotSupporterRoute;
